import { request } from '@/common/services/request';

export const FEISHU_BITABLE_CONNECTION_TYPE = 'feishu-bitable';
export const FEISHU_BITABLE_COLLECTION_TYPE = 'feishu-bitable-operation-metrics';
export const FEISHU_BITABLE_EXPENSE_COLLECTION_TYPE = 'feishu-bitable-operation-expense';
export const FEISHU_BITABLE_GROSS_MARGIN_COLLECTION_TYPE = 'feishu-bitable-operation-gross-margin';
export const FEISHU_BITABLE_SALARY_COLLECTION_TYPE = 'feishu-bitable-operation-salary';
export const FEISHU_BITABLE_STORE_COLLECTION_TYPE = 'feishu-bitable-operation-stores';
export const FEISHU_CONTACT_CONNECTION_TYPE = 'feishu-contact';
export const FEISHU_CONTACT_COLLECTION_TYPE = 'feishu-contact';
export const HOSE_CONNECTION_TYPE = 'hose';
export const HOSE_EXPENSE_COLLECTION_TYPE = 'hose-expense';
export const HOSE_LOAN_COLLECTION_TYPE = 'hose-loan';
export const HOSE_PAYMENT_COLLECTION_TYPE = 'hose-payment';
export const HOSE_REQUISITION_COLLECTION_TYPE = 'hose-requisition';

const CONNECTION_TYPES = new Set([
  FEISHU_BITABLE_CONNECTION_TYPE,
  FEISHU_CONTACT_CONNECTION_TYPE,
  HOSE_CONNECTION_TYPE,
]);
const COLLECTION_TYPES = new Set([
  FEISHU_BITABLE_COLLECTION_TYPE,
  FEISHU_BITABLE_EXPENSE_COLLECTION_TYPE,
  FEISHU_BITABLE_GROSS_MARGIN_COLLECTION_TYPE,
  FEISHU_BITABLE_SALARY_COLLECTION_TYPE,
  FEISHU_BITABLE_STORE_COLLECTION_TYPE,
  FEISHU_CONTACT_COLLECTION_TYPE,
  HOSE_EXPENSE_COLLECTION_TYPE,
  HOSE_LOAN_COLLECTION_TYPE,
  HOSE_PAYMENT_COLLECTION_TYPE,
  HOSE_REQUISITION_COLLECTION_TYPE,
]);

const getPayloadData = (payload) => payload?.data || payload || {};

const toProTableResult = (result) => ({
  data: result.data || [],
  success: true,
  total: result.meta?.total || 0,
});

const requireType = (value, allowedTypes, message) => {
  if (!allowedTypes.has(value)) {
    throw new Error(message);
  }
  return value;
};

const getConnectionData = (data) => ({
  connectionType: requireType(data.connectionType, CONNECTION_TYPES, '请选择连接类型'),
  ...(data.credentials ? { credentials: data.credentials } : {}),
  name: data.name,
});

const getCollectionData = (data) => ({
  collectionType: requireType(data.collectionType, COLLECTION_TYPES, '请选择采集类型'),
  connectionId: data.connectionId,
  ...(data.fieldMapping ? { fieldMapping: data.fieldMapping } : {}),
  name: data.name,
  ...(data.sourceConfig ? { sourceConfig: data.sourceConfig } : {}),
});

export async function queryConnections(params) {
  const result = await request('/api/collect/connections', { method: 'GET', params });
  return toProTableResult(result);
}

export async function createConnection(payload) {
  const data = getPayloadData(payload);
  return request('/api/collect/connections', {
    method: 'POST',
    params: { organizationId: data.organizationId },
    data: getConnectionData(data),
  });
}

export async function updateConnection(payload) {
  const data = getPayloadData(payload);
  return request('/api/collect/connections', {
    method: 'PATCH',
    params: { connectionId: data.id, organizationId: data.organizationId },
    data: {
      ...(data.credentials ? { credentials: data.credentials } : {}),
      name: data.name,
    },
  });
}

export async function removeConnection(payload) {
  const data = getPayloadData(payload);
  return request('/api/collect/connections', {
    method: 'DELETE',
    params: { connectionId: data.id, organizationId: data.organizationId },
  });
}

export async function queryCollections(params) {
  const result = await request('/api/collect/collections', { method: 'GET', params });
  return toProTableResult(result);
}

export async function querySourceLog(params) {
  const result = await request('/api/collect/source-logs', { method: 'GET', params });
  return result.data;
}

export async function createCollection(payload) {
  const data = getPayloadData(payload);
  return request('/api/collect/collections', {
    method: 'POST',
    params: { organizationId: data.organizationId },
    data: getCollectionData(data),
  });
}

export async function updateCollection(payload) {
  const data = getPayloadData(payload);
  return request('/api/collect/collections', {
    method: 'PATCH',
    params: { collectionId: data.id, organizationId: data.organizationId },
    data: getCollectionData(data),
  });
}

export async function removeCollection(payload) {
  const data = getPayloadData(payload);
  return request('/api/collect/collections', {
    method: 'DELETE',
    params: { collectionId: data.id, organizationId: data.organizationId },
  });
}

export async function testFeishuConnection(params) {
  const result = await request('/api/collect/feishu/test', { method: 'POST', params });
  return result.data;
}

export async function testFeishuContactConnection(params) {
  const result = await request('/api/collect/feishu-contact/test', { method: 'POST', params });
  return result.data;
}

export async function testHoseConnection(params) {
  const result = await request('/api/collect/hose/test', { method: 'POST', params });
  return result.data;
}

export async function loadFeishuMetadata(params) {
  const result = await request('/api/collect/feishu/metadata', { method: 'GET', params });
  return result.data;
}
